import { CustomerCompany } from 'module/api/company/types';
import { Field } from 'module/api/field/types';
import { SourceType } from 'module/api/filter/types';
import { fieldToFilterableField } from 'module/helpers/filter/type-transformers';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import {
  CustomNodeFieldConfigResponse,
  CustomNodeResponseField,
} from 'api/custom-section/types';
import { MeetingDetailsResponse } from 'api/custom-section/types/meeting-detail';

const fieldsIntoLookup = (fields: CustomNodeResponseField[]) => {
  return fields.reduce((accumulator, field) => {
    accumulator[field.fieldName] = field.fieldValue;

    return accumulator;
  }, {});
};

export const accountBlockResponseToLookup = (
  response: CustomNodeFieldConfigResponse,
) => {
  const company = response as unknown as CustomerCompany;

  return {
    ...response,
    ...company.financialMetrics,
    ...fieldsIntoLookup(response.fields ?? []),
  };
};
export const meetingBlockResponseToLookup = (
  response: MeetingDetailsResponse,
) => {
  return {
    ...response,
    ...fieldsIntoLookup(response.fields ?? []),
    ...(response.meta?.participants != null
      ? { participants: response.meta.participants }
      : {}),
  };
};
export const filterableFieldsFromFieldNames = (
  fieldNames: string[],
  sourceFields: FilterableField[],
  fieldsInResponse: Field[],
  responseFieldsSourceType: SourceType,
): FilterableField[] => {
  return fieldNames
    .map((fieldName) => {
      const foundInMeetingFields = sourceFields?.find(
        (field) => field.fieldName === fieldName,
      );

      if (foundInMeetingFields) {
        return foundInMeetingFields;
      }
      const foundInResponse = fieldsInResponse.find(
        (x) => x.fieldName === fieldName,
      );

      if (foundInResponse) {
        return fieldToFilterableField(
          foundInResponse,
          responseFieldsSourceType,
        );
      }

      return undefined;
    })
    .filter((field) => field != null);
};
